import _size from "lodash/size";
import _some from "lodash/some";

export const isSameObject = (objectA, objectB) => {
  if (!objectA || !objectB) return false;

  const keysObjectA = Object.keys(objectA);
  const keysObjectB = Object.keys(objectB);

  if (_size(keysObjectA) !== _size(keysObjectB)) return false;

  const isDifferent = _some(keysObjectA, (key) => {
    return objectA[key] !== objectB[key];
  });

  return !isDifferent;
};



// WEBPACK FOOTER //
// ./src/services/utils/isSameObject.js